import * as moment from 'moment';

export interface IFormatNumberHelper {
    getFormatter(decimals?: number, rounded?: boolean): Intl.NumberFormat;
    format(input: any, decimals?: number, rounded?: boolean, replaceEmpty?: boolean): string;
    parse(input: string, decimals?: number): number | null;
}

export class FormatNumberHelper implements IFormatNumberHelper {
    static serviceId = 'formatNumberHelper';
    static $inject = ['moment'];

    private _formatters: Intl.NumberFormat[][][] = [];

    constructor(private _moment: moment.Moment) {
    }

    private initCache(locale: string, rounded: boolean) {
        if (!this._formatters[locale]) {
            this._formatters[locale] = [];
        }

        if (!this._formatters[locale][rounded]) {
            this._formatters[locale][rounded] = [];
        }
    }

    getFormatter(decimals?: number, rounded: boolean = true): Intl.NumberFormat {
        const maxDecimal: number = 20;
        const minDecimal: number = 0;
        let dec = (decimals === undefined || decimals === null || (decimals as any) === '' || isNaN(Number(decimals)))
            ? 2
            : decimals;
        dec = Math.max(minDecimal, dec); //always greater than zero
        dec = Math.min(maxDecimal, dec); //always less than 20
        const locale = this._moment.locale();
        const localeString = this.getLocaleString();
        this.initCache(locale, rounded);
        if (!this._formatters[locale][rounded][dec]) {
            this._formatters[locale][rounded][dec] = Intl.NumberFormat(
                localeString,
                {
                    maximumFractionDigits: rounded ? dec : maxDecimal,
                    minimumFractionDigits: rounded ? dec : minDecimal
                }
            );
        }
        return this._formatters[locale][rounded][dec];
    }

    getLocaleString(locale?: string): string {
        if (!locale) {
            locale = this._moment.locale();
        }
        return locale === 'en'
            ? 'en-GB'
            : locale === 'fr'
                ? 'fr-FR'
                : locale === 'nl'
                    ? 'nl-NL'
                    : 'en-GB';
    }

    format(input: any, decimals?: number, rounded: boolean = true, replaceEmpty: boolean = true): string {
        const format = this.getFormatter(decimals, rounded);
        let result = input || input === 0
            ? format.format(input)
            : '';
        if (replaceEmpty && (!result || result === 'NaN')) {
            result = '-';
        }
        return result;
    }

    parse(input: string, decimals?: number): number | null {
        const testNumber = 1000.1;
        const localized = this.getFormatter(1).format(testNumber);
        const decimalSeparator = localized.substring(localized.length - 2, localized.length - 1);
        let thousandSeparator = localized.substring(1, 2);
        thousandSeparator = thousandSeparator === '0' ? '' : thousandSeparator;
        let normalized = input
            .replace(decimalSeparator, '.');
        if (thousandSeparator && input.indexOf(thousandSeparator) >= 0) {
            //UNTESTED!!!
            normalized = normalized.replace(new RegExp(thousandSeparator, 'g'), '');
        }
        const parsed = input && input !== '-'
            ? parseFloat(normalized)
            : null;
        return parsed;
    }
}